export const BuildInfo = {timestamp:1782430215000}
